module.exports = __webpack_public_path__ + "static/media/DKS-55.2960ff7c.png";